const OverView = () => import('./pages/Overview.vue')
const Invoices = () => import('./pages/Invoices.vue')
const UsageReport = () => import('./pages/UsageReport.vue')

const plansSubscriptionsRoutes = [
  {
    path: 'overview',
    name: 'plan-overview',
    component: OverView,
    meta: { requiresAuth: true, menuType: 'PlanBilling' },
  },
  {
    path: 'invoices',
    name: 'plan-invoices',
    component: Invoices,
    meta: { requiresAuth: true, menuType: 'PlanBilling' },
  },
  {
    path: 'usage-report',
    name: 'plan-usage-report',
    component: UsageReport,
    meta: { requiresAuth: true, menuType: 'PlanBilling' },
  },
]

export default plansSubscriptionsRoutes
